import { render, staticRenderFns } from "./GraficoPieDashboard.vue?vue&type=template&id=dadc0bec"
import script from "./GraficoPieDashboard.vue?vue&type=script&lang=js"
export * from "./GraficoPieDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports